import { cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

type Props = {
  title: string;
  children?: any;
};

const Row = styled.span`
  display: flex;

  & + * {
    margin-block-start: 16px;
  }
`;

const InfoTitle = styled.span`
  flex: 0 0 152px;
  padding-inline-end: 8px;
  color: ${cssThemedValue('textSecondary')};
`;

const InfoContent = styled.span`
  flex: 1 1 auto;
`;

export const InfoSubRow = ({ title, children }: Props) => (
  <Row>
    <InfoTitle>{title}</InfoTitle>
    <InfoContent>{children}</InfoContent>
  </Row>
);
